export const FILE_TYPE_P60 = 'P60'
export const FILE_TYPE_P45 = 'P45'
export const FILE_TYPE_PAYSLIP = 'Payslip'
export const FILE_TYPE_INCOME_RECORD = 'IncomeRecord'
export const FILE_TYPE_INCOME_PLATFORM_REPORT = 'IncomePlatformReport'
export const FILE_TYPE_EXPENSE_RECORD = 'ExpenseRecord'
export const FILE_TYPE_BANK_STATEMENT = 'BankStatement'
export const FILE_TYPE_SPREADSHEET = 'Spreadsheet'
export const FILE_TYPE_PENSIONS_DOCUMENT = 'PensionsDocument'
export const FILE_TYPE_OTHER = 'Other'
export const FILE_TYPE_INTEREST_CERTIFICATE = 'InterestCertificate'
export const FILE_TYPE_DIVIDEND_VOUCHER = 'DividendVoucher'
export const FILE_TYPE_PAYMENT_SCHEDULE = 'PaymentSchedule'
export const FILE_TYPE_ANNUAL_SUMMARY = 'AnnualSummary'
export const FILE_TYPE_CERTIFICATE = 'Certificate'
export const FILE_TYPE_P11D = 'P11D'
export const FILE_TYPE_INVESTMENT_SCHEME_CERTIFICATE = 'InvestmentSchemeCertificate'
export const FILE_TYPE_FINAL_RETURN = 'FinalReturn'
export const FILE_TYPE_PREVIOUS_RETURN = 'PreviousReturn'
export const FILE_TYPE_TAX_CALCULATION = 'TaxCalculation'
export const FILE_TYPE_SUBMISSION_RESPONSE = 'SubmissionResponse'
export const FILE_TYPE_TAX_SCHEDULE = 'TaxSchedule'
export const FILE_TYPE_TAX_SUMMARY = 'TaxSummary'
const FILE_TYPE_CIS_PAYMENT_STATEMENT = 'CisPaymentStatement'
const FILE_TYPE_IMAGE = 'Image'
export const FILE_TYPE_ID_DOCUMENT = 'IdDocument'
export const FILE_TYPE_PROOF_OF_ADDRESS = 'ProofOfAddress'
export const FILE_TYPE_TAX_REGISTRATION_SUBMISSION = 'TaxRegistrationSubmission'
export const FILE_TYPE_PAYE_CODING_NOTICE = 'PAYECodingNotice'
export const FILE_TYPE_CAPITAL_GAINS_REPORT = 'CapitalGainsReport'
export const FILE_TYPE_CAPITAL_GAINS_COMPUTATION = 'CapitalGainsComputation'
export const FILE_TYPE_SHARE_AWARD_AGREEMENT = 'ShareAwardAgreement'
export const FILE_TYPE_SALE_SUMMARY = 'SaleSummary'
export const FILE_TYPE_TAX_CONSULTATION_CUSTOMER_DOCUMENT = 'TaxConsultationCustomerDocument'
export const FILE_TYPE_TAX_CONSULTATION_SUMMARY = 'TaxConsultationSummary'
export const FILE_TYPE_ID_VERIFICATION_VIDEO = 'IdentityVerificationVideo'
export const FILE_TYPE_TAX_RELIEF_CLAIM_CERTIFICATE = 'TaxReliefClaimCertificate'
export const FILE_TYPE_TAX_RELIEF_CLAIM_COMPLETED_FORM = 'TaxReliefClaimCompletedForm'
export const FILE_TYPE_TAX_RELIEF_CLAIM_PROOF_OF_POSTAGE = 'TaxReliefClaimProofOfPostage'

export const FILE_TYPE_TITLES = {
    [FILE_TYPE_P60]: 'P60',
    [FILE_TYPE_P45]: 'P45',
    [FILE_TYPE_PAYSLIP]: 'Payslip',
    [FILE_TYPE_INCOME_RECORD]: 'Income record',
    [FILE_TYPE_INCOME_PLATFORM_REPORT]: 'Income record',
    [FILE_TYPE_EXPENSE_RECORD]: 'Expense record',
    [FILE_TYPE_BANK_STATEMENT]: 'Bank statement',
    [FILE_TYPE_SPREADSHEET]: 'Spreadsheet',
    [FILE_TYPE_PENSIONS_DOCUMENT]: 'Pensions document',
    [FILE_TYPE_OTHER]: 'Other',
    [FILE_TYPE_INTEREST_CERTIFICATE]: 'Interest certificate',
    [FILE_TYPE_DIVIDEND_VOUCHER]: 'Dividend voucher',
    [FILE_TYPE_PAYMENT_SCHEDULE]: 'Payment schedule',
    [FILE_TYPE_ANNUAL_SUMMARY]: 'Annual summary',
    [FILE_TYPE_CERTIFICATE]: 'Certificate',
    [FILE_TYPE_P11D]: 'P11D',
    [FILE_TYPE_INVESTMENT_SCHEME_CERTIFICATE]: 'Investment scheme certificate',
    [FILE_TYPE_FINAL_RETURN]: 'Final tax return',
    [FILE_TYPE_PREVIOUS_RETURN]: "Previous year's tax return",
    [FILE_TYPE_TAX_CALCULATION]: 'Tax calculations',
    [FILE_TYPE_SUBMISSION_RESPONSE]: 'HMRC filing receipt',
    [FILE_TYPE_TAX_SCHEDULE]: 'Tax schedule',
    [FILE_TYPE_TAX_SUMMARY]: 'Tax summary',
    [FILE_TYPE_CIS_PAYMENT_STATEMENT]: 'CIS payment statement',
    [FILE_TYPE_IMAGE]: 'Image',
    [FILE_TYPE_ID_DOCUMENT]: 'ID document',
    [FILE_TYPE_PROOF_OF_ADDRESS]: 'Proof of address',
    [FILE_TYPE_TAX_REGISTRATION_SUBMISSION]: 'UTR receipt',
    [FILE_TYPE_PAYE_CODING_NOTICE]: 'PAYE coding notice',
    [FILE_TYPE_CAPITAL_GAINS_REPORT]: 'Capital Gains Tax Report',
    [FILE_TYPE_CAPITAL_GAINS_COMPUTATION]: 'Capital gains computation',
    [FILE_TYPE_SHARE_AWARD_AGREEMENT]: 'Share award agreement',
    [FILE_TYPE_SALE_SUMMARY]: 'Sale summary',
    [FILE_TYPE_TAX_CONSULTATION_CUSTOMER_DOCUMENT]: 'Document',
    [FILE_TYPE_TAX_CONSULTATION_SUMMARY]: 'Summary',
    [FILE_TYPE_ID_VERIFICATION_VIDEO]: 'ID video',
    [FILE_TYPE_TAX_RELIEF_CLAIM_CERTIFICATE]: 'Tax relief claim certificate',
    [FILE_TYPE_TAX_RELIEF_CLAIM_COMPLETED_FORM]: 'Tax relief claim completed form',
    [FILE_TYPE_TAX_RELIEF_CLAIM_PROOF_OF_POSTAGE]: 'Tax relief claim proof of postage',
}

export const FILE_SUBTYPE_DRIVING_EXPENSES = 'DrivingExpenses'
export const FILE_SUBTYPE_CAR_LEASE_PAYMENTS = 'CarRentOrLeasePayments'
export const FILE_SUBTYPE_MILEAGE_LOG = 'MileageLog'
export const FILE_SUBTYPE_NON_DRIVING_EXPENSES = 'NonDrivingExpenses'
export const FILE_SUBTYPE_CAR_PURCHASE_RECEIPT = 'CarPurchaseReceipt'
export const FILE_SUBTYPE_KOINLY_REPORT = 'KoinlyReport'

export const FILE_SUBTYPE_TITLES = {
    [FILE_SUBTYPE_DRIVING_EXPENSES]: 'Driving expenses',
    [FILE_SUBTYPE_CAR_LEASE_PAYMENTS]: 'Car rent / lease payments',
    [FILE_SUBTYPE_MILEAGE_LOG]: 'Mileage log',
    [FILE_SUBTYPE_NON_DRIVING_EXPENSES]: 'Non-driving expenses',
    [FILE_SUBTYPE_CAR_PURCHASE_RECEIPT]: 'Car purchase receipt',
    [FILE_SUBTYPE_KOINLY_REPORT]: 'Koinly Crypto Tax Report',
}
